import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";

/**
 * Page-free capabilities a leads/CRM filter can require; a surface grants them (`SurfaceSelection.grants`,
 * resolved by {@link createLeadsGrants}). A capability must serve ≥2 filters or map to a real workspace
 * entitlement — otherwise the filter should gate itself via `requires` (data) or a `build()` veto, so this
 * vocabulary never regrows into a per-filter boolean bag (the `IFiltersSettings` it replaces).
 */
export const leadsCapabilityMap = {
    excludeFilters: "exclude-filters",
    companyFilter: "company-filter",
    /** The CRM category's legacy single-object fields filter. */
    crmLegacyFilter: "crm-legacy-filter",
    /** Backend-described CRM custom filters (workspace entitlement). */
    crmCustomFilters: "crm-custom-filters",
    /** The net-new / in-CRM scope radio. */
    crmScope: "crm-scope",
} as const;

/** Per-provider exclude-by-CRM capability, e.g. `exclude-by-crm:salesforce`. */
export type ExcludeByCrmCapability = `exclude-by-crm:${CrmIntegrationProvider}`;

export const excludeByCrmCapability = (provider: CrmIntegrationProvider): ExcludeByCrmCapability =>
    `exclude-by-crm:${provider}`;

export type LeadsCapability = (typeof leadsCapabilityMap)[keyof typeof leadsCapabilityMap] | ExcludeByCrmCapability;
